module.exports = __webpack_public_path__ + "static/media/dragon-female.6cb56bf7.png";